/**
 * tab.component.ts
 *
 * The purpose of this class is to provide base methods for updating a patient's
 * information from a tab.
 *
 * The parent component is assumed to be the PatientDashboard component of this project.
 */

import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { PatientDashboardStore } from '../../state/dashboard-page.store';
import { AuthStore } from 'src/app/calvin-emr-shared/state/auth/auth.store';

@Component({
  selector: 'app-base',
  template: ` <p>tab works!</p> `,
  styles: [],
  standalone: true,
})
export class PatientDashboardTabComponent implements OnInit, OnDestroy {
  isLoading = true;

  protected patientStore = inject(PatientDashboardStore);
  private authStore = inject(AuthStore);

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  startLoading(): void {
    this.isLoading = true;
  }

  stopLoading(): void {
    this.isLoading = false;
  }

  get isAdmin(): boolean {
    return this.authStore.isAdmin();
  }

  updatePatientField(field: string, data: any) {
    this.patientStore.setField({ field, data });
  }
}
